import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	text: {
		fontWeight: tokens.fontWeightSemibold,
		color: tokens.colorNeutralStroke1Hover,
		marginBottom: "15px",
	},
	iconContainer: {
		marginTop: "10px",
		marginBottom: "10px",
	},
});
